module.exports = __webpack_public_path__ + "img/banner-icon-01.d42c4dcb.svg";